/* BaristaYOU: show Judge.me product reviews only when actual reviews exist. */
(()=>{'use strict';if(!document.body.classList.contains('template-product'))return;
const asCount=(el)=>{if(!el)return null;const v=el.getAttribute('data-number-of-reviews');if(v!==null&&/^\d+$/.test(v.trim()))return Number(v);return null};
function update(){
 const badges=document.querySelectorAll('.template-product .jdgm-prev-badge');
 let confirmed=false;
 badges.forEach(b=>{const title=document.querySelector('.template-product .product__title__wrapper');if(title&&!title.contains(b)){title.appendChild(b)}let count=asCount(b);let ok=count!==null&&count>0;b.style.display=ok?'':'none';if(ok)confirmed=true});
 document.querySelectorAll('.template-product .jdgm-review-widget').forEach(w=>{
  const candidates=[w,w.querySelector('[data-number-of-reviews]'),...badges];
  const nums=candidates.map(asCount).filter(n=>n!==null);
  const realReviews=w.querySelectorAll('.jdgm-rev:not(.jdgm-rev--placeholder)').length;
  const has=nums.some(n=>n>0)||(realReviews>0)||(confirmed&&nums.length===0);
  w.dataset.byHasReviews=has?'true':'false';
  const parent=w.closest('.shopify-section');
  if(parent&&parent.querySelectorAll('.jdgm-review-widget').length===1)parent.style.display=has?'':'none';
 });
}
let pending=false;const schedule=()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;update()})};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
const obs=new MutationObserver(schedule);obs.observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['data-number-of-reviews','class']});
document.addEventListener('shopify:section:load',schedule);
})();
